import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames'
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import { userDispatcher } from '~/misc/userAccount'
import * as modes from '~/modules/modal/modes';
import {push as changeURL} from 'react-router-redux';
import accounting from '~/misc/accounting';
import { createBookDynamic, getMyBookingsAction } from "~/modules/bookings/action"
import { status as loadStatus } from "~/misc/loadStatus";
import { track } from '~/misc/metrics';
import { getLocation, getSearchId } from "~/misc/actionLocation";
const loadsmartUrl = "https://liveloads.page.link/truckerpath"
const Status = {
  BOOKNOW: 'booknow',
  BOOKSUCCESS: 'booksuccess',
  BOOKLSSUCCESS: 'booklssuccess',
  BOOKFAIL: 'bookfail'
}

class Booknow extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      status: Status.BOOKNOW
    }
  }
  book = () => {
    const { createBookDynamic, getMyBookings ,context: { shipmentId, nextNode } } = this.props
    createBookDynamic({shipmentId, nextNode}).then(({code, id}) => {
      getMyBookings()
      switch (code) {
        case loadStatus.BOOK_SUCCESS:
          {
            track("Book Results", {
              Result: "Success",
              loadId: shipmentId,
              searchId: getSearchId(),
              Placement: getLocation(),
              BookId: id,
            })
            return this.setState({
              status: Status.BOOKSUCCESS
            }) 
          }
        default:{
          track("Book Results", {
            Result: "Failed",
            loadId: shipmentId,
            searchId: getSearchId(),
            Placement: getLocation(),
            BookId: id,
          })
          return this.setState({
            status: Status.BOOKFAIL
          })
        }
          
      }
    }).catch((err) => {
      console.log(err)
      this.setState({
        status: Status.BOOKFAIL
      })
    });
  }  
  render () {
    const { status } = this.state;
    switch(status) {
      case Status.BOOKNOW:
        return this.renderBookNow();
      case Status.BOOKSUCCESS:
        return this.renderBookSuccess();
      case Status.BOOKFAIL:
        return this.renderBookFail();
      case Status.BOOKLSSUCCESS:
        return this.renderLSBookSuccess();
    }
  }
  renderBookNow() {
    const {closePop, gotoVerify, context } = this.props;
    const { price, shipmentId } = context;
    return (
      <div className={css.popwrap}>
        <header className={css.title}>
          <p>Book Now!</p>
        </header>
        <main className={css.mainNormal}>
          You are about to book this load for price {accounting.formatMoney(price)}.
        </main>
        <footer className={css.footer}>
          <div className={css.footerRow}>
            <Button
              onClick={()=>{
                closePop();
              }}
              className={css.lineButton}
            >
              Cancel
            </Button>
            <Button
              mods={['action']}
              className={css.button}
              onClick={()=>{
                this.book();
              }}
            >
              Book
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
  renderBookSuccess() {
    const {closePop} = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.header}>
          <div className={cs(css.icon, css.iconSuccess)}></div>
          <p className={css.title}>Successful</p>
        </header>
        <main className={css.mainNormal}>
          Your booking is successful, contact the broker now and start moving
        </main>
        <footer className={css.footer}>
          <div className={css.footerRowSingle}>
            <Button
              mods={['action']}
              onClick={()=>{
                closePop();
              }}
            >
              OK
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
  renderLSBookSuccess() {
    const {closePop} = this.props;
    return (
      <div className={css.popwrap}>
        <header className={css.header}>
          <div className={cs(css.icon, css.iconSuccess)}></div>
          <p className={css.title}>Successful</p>
        </header>
        <main className={css.mainNormal}>
          Your booking is successful, contact the broker now and start moving
        </main>
        <footer className={css.footer}>
          <div className={css.footerRowSingle}>
            <Button
              mods={['action']}
              onClick={()=>{
                closePop();
                window.open(loadsmartUrl);
              }}
            >
              Open Loadsmart
            </Button>
          </div>
        </footer> 
      </div>
    )
  }
  renderBookFail() {
    return (
      <div className={css.popwrap}>
        Book fail, please try again.
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.BOOKNOW),
  createBookDynamic: (props, {shipmentId, nextNode}) => createBookDynamic(shipmentId, nextNode),
  getMyBookings: () => getMyBookingsAction()
}))(Booknow);


// WEBPACK FOOTER //
// ./src/components/Popup/Booknow/index.js